// extracted by mini-css-extract-plugin
export default {"products":"ProductContainer_products__nuLaa"};